<template>
  <div class="container-fluid">
    <div class="mt-4">
      <Breadcrumb :breadcrumbs="breadcrumbs"/>

      <router-view v-if="isEnabled && $withPolicy('driver-indication', 'viewer')"/>

      <div v-else>
        <h1>Aplicativo não habilitado</h1>
      </div>
    </div>
  </div>
</template>

<script>
  import BreadcrumbMixin from '@/mixins/BreadcrumbMixin'
  import Breadcrumb from '@/components/shares/Breadcrumb'
  import GetAccountApps from '@/mixins/GetAccountApps'
  import { DRIVER_INDICATION, hasActiveProduct } from '@/models/accountProducts'

  export default {
    components: { Breadcrumb },
    computed: {
      isEnabled() {
        return hasActiveProduct(this.getAccountApps, DRIVER_INDICATION)
      }
    },
    mixins: [BreadcrumbMixin, GetAccountApps],
    name: 'driver-indication'
  }
</script>

<style scoped>

</style>
